import React, { FC, useCallback, useContext } from 'react';
import { Form, Cascader, Input, Button } from 'antd';
import { LabelType } from '@/enum';
import { url } from '@/url';
import { useHistory } from 'react-router';
import { homeContext } from './context';
import { ClassifyFormValues } from './interface';
import styles from './home.module.less';

export const ClassifyForm: FC = () => {
  const {
    commonFormItemProps,
    categoryCascaderOptionsState,
  } = useContext(homeContext);

  const history = useHistory();

  const onStartClassify = useCallback(
    ({ category: [gender, c1, c2], retailer }: ClassifyFormValues) => {
      history.push(url.label({ gender, c1, c2, type: LabelType.Classify }, { retailer }));
    },
    [history]
  );
  return (
    <Form<ClassifyFormValues> className={styles.form} size="large" onFinish={onStartClassify}>
      <Form.Item
        {...commonFormItemProps}
        label="类别"
        name="category"
        required
        rules={[{ required: true, message: '请选择类别' }]}
      >
        <Cascader placeholder="请选择商品类别" options={categoryCascaderOptionsState.data} />
      </Form.Item>
      <Form.Item
        {...commonFormItemProps}
        label="零售商"
        name="retailer"
      >
        <Input placeholder="请填写需要指定的零售商" />
      </Form.Item>
      <Button htmlType="submit" type="primary" size="large" className={styles.button}>
        开始标注
      </Button>
    </Form>
  )
}